import React from 'react'

function GraphsCard(props) {
    return (
        <div className="card card-container">
            <div className="card-header theme-color">
                 {props.title} {props?.subTitle && <span className="float-end font-12">{props?.subTitle}</span>}
            </div>
            <div className="card-body">
                {props.children}
            </div>
        </div>
    )
}

export default GraphsCard
